export const New = () => {
  return (
    <div className="new">
      <p className="new__title">Що нового</p>
      <p className="new__description">
        Оновлено розділ бонусів і акцій Mine Slot: більше регулярних пропозицій
        для слотів і казино.
      </p>
      <p className="new__description">
        У каталозі слотів додано фільтри за провайдером і RTP.
      </p>
      <p className="new__description">
        Нові тематичні слоти в стилі Minecraft та сезонні івенти на червень 2026.
      </p>
      <p className="new__description">
        Додано підтримку Face ID і Touch ID.
      </p>
      <p className="new__description">
        Виправлено проблему з push-сповіщеннями на частині пристроїв з Android
        10.
      </p>
      <p className="new__description">
        Виправлено відображення надто дрібного тексту в налаштуваннях для
        користувачів Android.
      </p>
    </div>
  );
};
